import Konva from "konva";

export class SlidableGroup extends Konva.Group {
  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setLeft: (this: SlidableGroup) => void = () => {};

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this, @typescript-eslint/no-empty-function
  setCenter: (this: SlidableGroup) => void = () => {};
}
